import { render, staticRenderFns } from "./SsoCallback.vue?vue&type=template&id=64db6b1f&scoped=true&"
import script from "./SsoCallback.vue?vue&type=script&lang=js&"
export * from "./SsoCallback.vue?vue&type=script&lang=js&"
import style0 from "./SsoCallback.vue?vue&type=style&index=0&id=64db6b1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db6b1f",
  null
  
)

export default component.exports